import { render, staticRenderFns } from "./referral.pug?vue&type=template&id=57df8263&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./referral.scss?vue&type=style&index=0&id=57df8263&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57df8263",
  null
  
)

export default component.exports